import * as visibleFields from 'serviceWorker/db/visibleFields/visibleFields';
import * as visibleFieldsService from 'serviceWorker/db/visibleFields/visibleFieldsService';


import { visibleFieldContract, type VisibleFieldsEditRequest } from 'shared/domain/visibleField/visibleFieldContract';
import { broadcastAllVisibleFields } from 'serviceWorker/broadcasts/visibleFields';
import { debugLog } from 'shared/logger/debugLog';
import { visibleFieldsEditor } from './editVisibleFields';
import {
  fetchUpdatedVisibleFields,
  fetchVisibleFields,
} from './fetchVisibleFields';
import { Services } from 'shared/domain/messages/message';
import { createSyncedEntity } from '../factories/createSyncedEntity';

/** Download and sync of the visibleFields; the source's `sync` is its entry point. */
export const visibleFieldsSync = createSyncedEntity({
  entityName: Services.VISIBLE_FIELDS,
  contract: visibleFieldContract,
  repository: visibleFields,
  service: visibleFieldsService,
  fetch: fetchVisibleFields,
  fetchUpdated: fetchUpdatedVisibleFields,
  publishCollection: broadcastAllVisibleFields,
});

export function handleEditVisibleFields(
  detail: VisibleFieldsEditRequest
): Promise<void> {
  debugLog('editVisibleFields', detail);
  return visibleFieldsEditor.execute(detail.visibleFieldsEdit, detail.uniqueId);
}
